// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__aB4-e","inner":"Footer_inner__ooYhI","nextIcon":"Footer_nextIcon__3pXzI","innerLeft":"Footer_innerLeft__1ee3m"};